/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const createBusinessPartnerResponseDtoKindEnum = {
  contact: "contact",
  on_behalf: "on_behalf",
} as const

export type CreateBusinessPartnerResponseDtoKindEnumKey =
  (typeof createBusinessPartnerResponseDtoKindEnum)[keyof typeof createBusinessPartnerResponseDtoKindEnum]

export type CreateBusinessPartnerResponseDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  kind: CreateBusinessPartnerResponseDtoKindEnumKey
  /**
   * @type string
   */
  businessRelationshipId: string
  /**
   * @type string
   */
  organizationName: string
  /**
   * @type string
   */
  organizationId: string
  /**
   * @description User ID of the created contact (contact kind only)
   * @type string | undefined
   */
  userId?: string
}
